module.exports = {"id":"177981","name":"Fernando Tissone","rating":"74","photo":"./data/images/photos/4/177981.png","club":{"name":"CD Aves","logo":"./data/images/clubs/CDAves.png"},"positions":["MC","MDC"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/FernandoTissone0.json
// module id = 1423
// module chunks = 0